import { TStaffSurveyData } from "../types";

export interface SexualHarassmentFormValues {
  IP_001_genero: string;
  IP_002_edad: string;
  IP_003_comunidad: string;
  IP_004_etnia: string;
  IL_001_contrato: string;
  IL_002_turno: string;
  IL_003_tiempoTrabajando: string;
  IL_004_area: string;
  IL_005_contactoConClientes: string;
  IL_006_puestoDeTrabajo: string;
  IL_007_participacionEnComite: string;
  IL_008_jefe: string;
  IL_009_centroDeTrabajo: string;
  SP_001_conocePoliticaDePrevencion: string;
  SP_002_haSidoCapacitado: string;
  SP_003_canalDeDenunciasExiste: string;
  SP_004_011_canalesDeDenuncias: string[];
  SP_012_conoceProcesoDeInvestigacion: string;
  PL_001_percepcionLideres: string;
  TOL_001_bromasSexistas: string;
  TOL_002_bromasSobreIdentidadSexual: string;
  TOL_003_bromasSobreAparienciaFisica: string;
  TOL_004_invitarASalir: string;
  TOL_005_contactarPorRedesSociales: string;
  TOL_006_solicitarMaterialSexual: string;
  TOL_007_rozamientosIndebidos: string;
  TOL_008_tocamientosIndebidos: string;
  TOL_009_mirarConConnotacionSexual: string;
  TOL_010_invitarASalir: string;
  TOL_011_insinuarMejoresCondicionesACambioDeRelaciones: string;
  TOL_012_ameazarConSuspenderContrato: string;
  CPT_001: string;
  CPT_002: string;
  CPT_003: string;
  CPT_004: string;
  AD_001_haSidoObjetoDeAcoso: string;
  AT_001_comentariosConContenidoSexual: string;
  AT_002_comentariosSobreOrientacionSexual: string;
  AT_003_comentariosSobreAparienciaFisica: string;
  AT_004_invitarASalir: string;
  AT_005_contactarPorRedesSociales: string;
  AT_006_solicitarMaterialSexual: string;
  AT_007_rozamientosIndebidos: string;
  AT_008_tocamientosIndebidos: string;
  AT_009_mirarConConnotacionSexual: string;
  AT_010_invitarASalir: string;
  AT_011_insinuarMejoresCondicionesACambioDeRelaciones: string;
  AT_012_amenazarConSuspenderContrato: string;
  AD_002_013: string[];
  FRE_001_frecuencia: string;
  PAD_001_002: string[];
  PAD_003_007: string[];
  AAD_001_008: string[];
  BAD_001_010: string[];
  BAD_010: string;
  COS_001_005: string[];
  TD_001: string;
  TD_002_013: string[];
  TT_001: string;
  TT_002: string;
  TT_003: string;
  TT_004: string;
  TT_005: string;
  TT_006: string;
  TT_007: string;
  TT_008: string;
  TT_009: string;
  TT_010: string;
  TT_011: string;
  TT_012: string;
  ACT_001_008: string[];
  DANIEL_001: string;
  DANIEL_002: string;
  DANIEL_003: string;
  DANIEL_004: string;
  DANIEL_005: string;
  DANIEL_006: string;
  MARIANA_001: string;
  MARIANA_002: string;
  MARIANA_003: string;
  MARIANA_004: string;
  MARIANA_005: string;
  MARIANA_006: string;
  SANDRA_001: string;
  SANDRA_002: string;
  SANDRA_003: string;
  SANDRA_004: string;
  SANDRA_005: string;
  SANDRA_006: string;
  CLAUDIA_001: string;
  CLAUDIA_002: string;
  CLAUDIA_003: string;
  CLAUDIA_004: string;
  CLAUDIA_005: string;
  CLAUDIA_006: string;
  AD_014: string;
  CON_001: string;
  CON_003: string;
  CON_004: string;
  CON_005: string;
  CON_006: string;
  CON_007: string;
  SAT_001: string;
}

// Utility functions for data transformation
const addToDataIfNotEmpty = (data: any, key: string, value: any) => {
  if (value) data[key] = value;
};

const addToDataIfContains = (data: any, list: any, key: string) => {
  if (list.includes(key)) data[key] = true;
  else data[key] = false;
};

const checkIfCheckboxIsEmpty = (list: string[]) => {
  return list.every((element) => element === "");
};

const addCase = (
  data: any,
  id: number,
  code: string,
  case_resolution: string,
  natural_heterosexuality: string,
  exacerbated_intent: string,
  victim_responsibility: string,
  overreaction: string,
  ulterior_motives: string
) => {
  data[`case_${code}`] = id;
  data[`case_${code}_case_resolution`] = case_resolution;
  data[`case_${code}_natural_heterosexuality`] = natural_heterosexuality;
  data[`case_${code}_exacerbated_intent`] = exacerbated_intent;
  data[`case_${code}_victim_responsibility`] = victim_responsibility;
  data[`case_${code}_overreaction`] = overreaction;
  data[`case_${code}_ulterior_motives`] = ulterior_motives;
};

export const transformSexualHarassmentSurveyData = (
  formValues: SexualHarassmentFormValues,
  survey: TStaffSurveyData,
  isLeader: boolean,
  esParteDeRecursosHumanos: boolean
) => {
  const data: any = {};

  // Personal Information
  addToDataIfNotEmpty(data, "ip_001", formValues.IP_001_genero);
  addToDataIfNotEmpty(data, "ip_002", formValues.IP_002_edad);
  addToDataIfNotEmpty(data, "ip_003", formValues.IP_003_comunidad);
  addToDataIfNotEmpty(data, "ip_004", formValues.IP_004_etnia);

  // Labor Information
  addToDataIfNotEmpty(data, "il_001", formValues.IL_001_contrato);
  addToDataIfNotEmpty(
    data,
    "il_002",
    survey.work_shifts.filter(
      (shift) => shift.id === parseInt(formValues.IL_002_turno)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "work_shift", parseInt(formValues.IL_002_turno));
  addToDataIfNotEmpty(data, "il_003", formValues.IL_003_tiempoTrabajando);
  addToDataIfNotEmpty(
    data,
    "il_004",
    survey.areas.filter(
      (area) => area.id === parseInt(formValues.IL_004_area)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "area", parseInt(formValues.IL_004_area));
  addToDataIfNotEmpty(data, "il_005", formValues.IL_005_contactoConClientes);
  addToDataIfNotEmpty(
    data,
    "il_006",
    survey.jobs.filter(
      (job) => job.id === parseInt(formValues.IL_006_puestoDeTrabajo)
    )[0]?.description
  );
  addToDataIfNotEmpty(data, "job", parseInt(formValues.IL_006_puestoDeTrabajo));
  addToDataIfNotEmpty(data, "il_007", formValues.IL_007_participacionEnComite);
  addToDataIfNotEmpty(data, "il_008", formValues.IL_008_jefe);

  const workplace = survey.workplaces.filter(
    (workplace) => workplace.id === parseInt(formValues.IL_009_centroDeTrabajo)
  )[0];
  if (workplace) addToDataIfNotEmpty(data, "il_009", workplace.description);
  addToDataIfNotEmpty(
    data,
    "workplace",
    parseInt(formValues.IL_009_centroDeTrabajo)
  );

  // Sexual Prevention
  addToDataIfNotEmpty(
    data,
    "sp_001",
    formValues.SP_001_conocePoliticaDePrevencion
  );
  addToDataIfNotEmpty(data, "sp_002", formValues.SP_002_haSidoCapacitado);
  addToDataIfNotEmpty(data, "sp_003", formValues.SP_003_canalDeDenunciasExiste);

  const reportChannels = survey.staff_survey.identified_report_channels ?? [];
  const selectedChannelIds = formValues.SP_004_011_canalesDeDenuncias
    .filter((v) => v !== "")
    .map((v) => parseInt(v, 10))
    .filter((id) => !Number.isNaN(id));
  if (selectedChannelIds.length > 0 && reportChannels.length > 0) {
    const validIds = selectedChannelIds.filter((id) =>
      reportChannels.some((ch) => ch.id === id)
    );
    data.identified_report_channel_ids = validIds;

    const selectedCodes = new Set<string>();
    for (const id of validIds) {
      const channel = reportChannels.find((ch) => ch.id === id);
      if (channel) {
        selectedCodes.add(channel.canonical_code);
      }
    }
    const allCodes = [
      "sp_004",
      "sp_005",
      "sp_006",
      "sp_007",
      "sp_008",
      "sp_009",
      "sp_010",
      "sp_011",
    ] as const;
    for (const code of allCodes) {
      data[code] = selectedCodes.has(code);
    }
  }

  addToDataIfNotEmpty(
    data,
    "sp_012",
    formValues.SP_012_conoceProcesoDeInvestigacion
  );

  // Perception Leaders (PL_001) — only when the survey includes this question
  if (survey.staff_survey.flag_010_show_pl_001 !== false) {
    addToDataIfNotEmpty(data, "pl_001", formValues.PL_001_percepcionLideres);
  }

  // Tolerance
  addToDataIfNotEmpty(data, "tol_001", formValues.TOL_001_bromasSexistas);
  addToDataIfNotEmpty(
    data,
    "tol_002",
    formValues.TOL_002_bromasSobreIdentidadSexual
  );
  addToDataIfNotEmpty(
    data,
    "tol_003",
    formValues.TOL_003_bromasSobreAparienciaFisica
  );
  addToDataIfNotEmpty(data, "tol_004", formValues.TOL_004_invitarASalir);
  addToDataIfNotEmpty(
    data,
    "tol_005",
    formValues.TOL_005_contactarPorRedesSociales
  );
  addToDataIfNotEmpty(
    data,
    "tol_006",
    formValues.TOL_006_solicitarMaterialSexual
  );
  addToDataIfNotEmpty(data, "tol_007", formValues.TOL_007_rozamientosIndebidos);
  addToDataIfNotEmpty(data, "tol_008", formValues.TOL_008_tocamientosIndebidos);
  addToDataIfNotEmpty(
    data,
    "tol_009",
    formValues.TOL_009_mirarConConnotacionSexual
  );
  addToDataIfNotEmpty(data, "tol_010", formValues.TOL_010_invitarASalir);
  addToDataIfNotEmpty(
    data,
    "tol_011",
    formValues.TOL_011_insinuarMejoresCondicionesACambioDeRelaciones
  );
  addToDataIfNotEmpty(
    data,
    "tol_012",
    formValues.TOL_012_ameazarConSuspenderContrato
  );

  // Concepts
  addToDataIfNotEmpty(data, "cpt_001", formValues.CPT_001);
  addToDataIfNotEmpty(data, "cpt_002", formValues.CPT_002);
  addToDataIfNotEmpty(data, "cpt_003", formValues.CPT_003);
  addToDataIfNotEmpty(data, "cpt_004", formValues.CPT_004);

  // Harassment Declaration
  addToDataIfNotEmpty(data, "ad_001", formValues.AD_001_haSidoObjetoDeAcoso);
  if (!checkIfCheckboxIsEmpty(formValues.AD_002_013)) {
    addToDataIfContains(data, formValues.AD_002_013, "ad_002");
    addToDataIfContains(data, formValues.AD_002_013, "ad_003");
    addToDataIfContains(data, formValues.AD_002_013, "ad_004");
    addToDataIfContains(data, formValues.AD_002_013, "ad_005");
    addToDataIfContains(data, formValues.AD_002_013, "ad_006");
    addToDataIfContains(data, formValues.AD_002_013, "ad_007");
    addToDataIfContains(data, formValues.AD_002_013, "ad_008");
    addToDataIfContains(data, formValues.AD_002_013, "ad_009");
    addToDataIfContains(data, formValues.AD_002_013, "ad_010");
    addToDataIfContains(data, formValues.AD_002_013, "ad_011");
    addToDataIfContains(data, formValues.AD_002_013, "ad_012");
    addToDataIfContains(data, formValues.AD_002_013, "ad_013");
  }

  // Harasser Profile
  if (!checkIfCheckboxIsEmpty(formValues.PAD_001_002)) {
    addToDataIfContains(data, formValues.PAD_001_002, "pad_001");
    addToDataIfContains(data, formValues.PAD_001_002, "pad_002");
  }
  if (!checkIfCheckboxIsEmpty(formValues.PAD_003_007)) {
    addToDataIfContains(data, formValues.PAD_003_007, "pad_003");
    addToDataIfContains(data, formValues.PAD_003_007, "pad_004");
    addToDataIfContains(data, formValues.PAD_003_007, "pad_005");
    addToDataIfContains(data, formValues.PAD_003_007, "pad_006");
    addToDataIfContains(data, formValues.PAD_003_007, "pad_007");
  }

  // Actions After Harassment
  // Backend stores each option as an individual "Sí."/"No." field.
  if (!checkIfCheckboxIsEmpty(formValues.AAD_001_008)) {
    const aadAnswers = formValues.AAD_001_008;
    const aadKeys = [
      "aad_001",
      "aad_002",
      "aad_003",
      "aad_004",
      "aad_005",
      "aad_006",
      "aad_007",
      "aad_008",
    ];
    aadKeys.forEach((key) => {
      addToDataIfNotEmpty(data, key, aadAnswers.includes(key) ? "Sí." : "No.");
    });
  }

  // Barriers to Reporting
  if (!checkIfCheckboxIsEmpty(formValues.BAD_001_010)) {
    addToDataIfContains(data, formValues.BAD_001_010, "bad_001");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_002");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_003");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_004");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_005");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_006");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_007");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_008");
    addToDataIfContains(data, formValues.BAD_001_010, "bad_009");

    const bad_list: string[] = formValues.BAD_001_010;
    if (bad_list.includes("otro"))
      addToDataIfNotEmpty(data, "bad_010", formValues.BAD_010);
  }

  // Technical Harassment
  addToDataIfNotEmpty(
    data,
    "at_001",
    formValues.AT_001_comentariosConContenidoSexual
  );
  addToDataIfNotEmpty(
    data,
    "at_002",
    formValues.AT_002_comentariosSobreOrientacionSexual
  );
  addToDataIfNotEmpty(
    data,
    "at_003",
    formValues.AT_003_comentariosSobreAparienciaFisica
  );
  addToDataIfNotEmpty(data, "at_004", formValues.AT_004_invitarASalir);
  addToDataIfNotEmpty(
    data,
    "at_005",
    formValues.AT_005_contactarPorRedesSociales
  );
  addToDataIfNotEmpty(
    data,
    "at_006",
    formValues.AT_006_solicitarMaterialSexual
  );
  addToDataIfNotEmpty(data, "at_007", formValues.AT_007_rozamientosIndebidos);
  addToDataIfNotEmpty(data, "at_008", formValues.AT_008_tocamientosIndebidos);
  addToDataIfNotEmpty(
    data,
    "at_009",
    formValues.AT_009_mirarConConnotacionSexual
  );
  addToDataIfNotEmpty(data, "at_010", formValues.AT_010_invitarASalir);
  addToDataIfNotEmpty(
    data,
    "at_011",
    formValues.AT_011_insinuarMejoresCondicionesACambioDeRelaciones
  );
  addToDataIfNotEmpty(
    data,
    "at_012",
    formValues.AT_012_amenazarConSuspenderContrato
  );

  // Frequency
  addToDataIfNotEmpty(data, "fre_001", formValues.FRE_001_frecuencia);

  // Costs
  // Backend stores each option as an individual "Sí."/"No." field.
  if (!checkIfCheckboxIsEmpty(formValues.COS_001_005)) {
    const cosAnswers = formValues.COS_001_005;
    const cosKeys = ["cos_001", "cos_002", "cos_003", "cos_004", "cos_005"];
    cosKeys.forEach((key) => {
      addToDataIfNotEmpty(data, key, cosAnswers.includes(key) ? "Sí." : "No.");
    });
  }

  // Witness Declaration
  addToDataIfNotEmpty(data, "td_001", formValues.TD_001);
  if (!checkIfCheckboxIsEmpty(formValues.TD_002_013)) {
    addToDataIfContains(data, formValues.TD_002_013, "td_002");
    addToDataIfContains(data, formValues.TD_002_013, "td_003");
    addToDataIfContains(data, formValues.TD_002_013, "td_004");
    addToDataIfContains(data, formValues.TD_002_013, "td_005");
    addToDataIfContains(data, formValues.TD_002_013, "td_006");
    addToDataIfContains(data, formValues.TD_002_013, "td_007");
    addToDataIfContains(data, formValues.TD_002_013, "td_008");
    addToDataIfContains(data, formValues.TD_002_013, "td_009");
    addToDataIfContains(data, formValues.TD_002_013, "td_010");
    addToDataIfContains(data, formValues.TD_002_013, "td_011");
    addToDataIfContains(data, formValues.TD_002_013, "td_012");
    addToDataIfContains(data, formValues.TD_002_013, "td_013");
  }

  // Technical Witness
  addToDataIfNotEmpty(data, "tt_001", formValues.TT_001);
  addToDataIfNotEmpty(data, "tt_002", formValues.TT_002);
  addToDataIfNotEmpty(data, "tt_003", formValues.TT_003);
  addToDataIfNotEmpty(data, "tt_004", formValues.TT_004);
  addToDataIfNotEmpty(data, "tt_005", formValues.TT_005);
  addToDataIfNotEmpty(data, "tt_006", formValues.TT_006);
  addToDataIfNotEmpty(data, "tt_007", formValues.TT_007);
  addToDataIfNotEmpty(data, "tt_008", formValues.TT_008);
  addToDataIfNotEmpty(data, "tt_009", formValues.TT_009);
  addToDataIfNotEmpty(data, "tt_010", formValues.TT_010);
  addToDataIfNotEmpty(data, "tt_011", formValues.TT_011);
  addToDataIfNotEmpty(data, "tt_012", formValues.TT_012);

  // Actions as Witness
  if (!checkIfCheckboxIsEmpty(formValues.ACT_001_008)) {
    addToDataIfContains(data, formValues.ACT_001_008, "act_001");
    addToDataIfContains(data, formValues.ACT_001_008, "act_002");
    addToDataIfContains(data, formValues.ACT_001_008, "act_003");
    addToDataIfContains(data, formValues.ACT_001_008, "act_004");
    addToDataIfContains(data, formValues.ACT_001_008, "act_005");
    addToDataIfContains(data, formValues.ACT_001_008, "act_006");
    addToDataIfContains(data, formValues.ACT_001_008, "act_007");
    addToDataIfContains(data, formValues.ACT_001_008, "act_008");
  }

  // Cases for Leaders and HR
  if (isLeader || esParteDeRecursosHumanos) {
    addCase(
      data,
      survey.cases.first.id,
      "001",
      formValues.DANIEL_001,
      formValues.DANIEL_002,
      formValues.DANIEL_003,
      formValues.DANIEL_004,
      formValues.DANIEL_005,
      formValues.DANIEL_006
    );
    addCase(
      data,
      survey.cases.second.id,
      "002",
      formValues.MARIANA_001,
      formValues.MARIANA_002,
      formValues.MARIANA_003,
      formValues.MARIANA_004,
      formValues.MARIANA_005,
      formValues.MARIANA_006
    );
    addCase(
      data,
      survey.cases.third.id,
      "003",
      formValues.SANDRA_001,
      formValues.SANDRA_002,
      formValues.SANDRA_003,
      formValues.SANDRA_004,
      formValues.SANDRA_005,
      formValues.SANDRA_006
    );
    addCase(
      data,
      survey.cases.fourth.id,
      "004",
      formValues.CLAUDIA_001,
      formValues.CLAUDIA_002,
      formValues.CLAUDIA_003,
      formValues.CLAUDIA_004,
      formValues.CLAUDIA_005,
      formValues.CLAUDIA_006
    );
  }

  // Additional questions
  addToDataIfNotEmpty(data, "ad_014", formValues.AD_014);

  // Confidence in Organization
  addToDataIfNotEmpty(data, "con_001", formValues.CON_001);
  addToDataIfNotEmpty(data, "con_003", formValues.CON_003);
  addToDataIfNotEmpty(data, "con_004", formValues.CON_004);
  addToDataIfNotEmpty(data, "con_005", formValues.CON_005);
  addToDataIfNotEmpty(data, "con_006", formValues.CON_006);
  addToDataIfNotEmpty(data, "con_007", formValues.CON_007);

  // Satisfaction
  addToDataIfNotEmpty(data, "sat_001", formValues.SAT_001);

  return data;
};
